module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_c('i', [_vm._v("The Age Returns")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—Motto of Lorenzo de’ Medici")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("Time itself is a circle, everything recurs")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—Friedrich Nietzsche")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_c('i', [_vm._v("What goes around comes around")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—Motto of the Hell’s Angels")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-335a713d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0